import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import WhatIfStepNavigator from 'Views/Page/Content/Modal/Components/WhatIfStepNavigator';
import useMobileLayout from 'Hooks/useMobileLayout';
import Content from 'Views/Page/Content/Modal/Layouts/WizardStepLayout/Content';

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  subtitle: {
    marginBottom: theme.spacing(4),
  },
  fields: {
    padding: theme.spacing(0),
  },
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  badgeImage: {
    marginBottom: theme.spacing(4),
    width: '140px',
    height: '140px',
  },
  navigator: {
    maxWidth: theme.dimensions.md,
  },
});

const Layout = ({
  className,
  classes,
}) => {
  const {
    saving,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  const isMobile = useMobileLayout();


  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classNames(classes.content, {
        [classes.contentDesktop]: !isMobile,
      })}
      >
        <Content />
      </div>
      <WhatIfStepNavigator
        className={classes.navigator}
        isLoading={saving}
        onNext={() => {
          clearModalCollection();
        }}
      >
        Finish
      </WhatIfStepNavigator>
    </Box>
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
